import { analytics } from 'analytics'
import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { paveApi } from 'api'
import PageLoader from 'components/common/Loader/PageLoader'
import { useAppSelector } from 'store/storeHooks'

import PageLayout from './PageLayout'

const PrivateRoutes = () => {
  const location = useLocation()
  const [getUserById, { isLoading }] = paveApi.useLazyGetUserByIdQuery()
  const auth = useAppSelector((state) => state.auth)

  useEffect(() => {
    if (!!auth.UserId) {
      getUserById(auth.UserId)
      analytics.identify(auth.UserId)
    }
  }, [auth.UserId, getUserById])

  if (isLoading) {
    return (
      <PageLayout hideMenu={true}>
        <PageLoader />
      </PageLayout>
    )
  }
  return auth.UserId ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  )
}

export default PrivateRoutes
